import nestAxios from './_nestAxios'

export const getFamilia = _id => nestAxios.get(`/familias/${_id}`)

export const getFamilias_Select = _idCategoria =>
  nestAxios.get('/familias', {
    params: {
      tipoConsulta: 'select',
      _idCategoria
    }
  })

export const insertarFamilia = data => nestAxios.post('/familias/nuevo', data)

export const actualizarFamilia = (_id, data) => nestAxios.put(`/familias/${_id}`, data)

export const eliminarFamilia = _id => nestAxios.delete(`/familias/${_id}`)

export const obtenerxCompaniaxBusquedaAsSelect2 = (idCompania, busqueda) => {
  const filtros = { _idCompania: idCompania }

  if (busqueda) {
    filtros.busqueda = busqueda
  }

  return nestAxios.get('/familias', {
    params: {
      tipoConsulta: 'select2-otros',
      ...filtros
    }
  })
}

